import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { services,industries } from "../Data";
import { FaFacebook, FaLinkedinIn } from "react-icons/fa";
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import { ReactComponent as ChatGPTLogo } from "./chatgpt.svg";
import { ReactComponent as ClaudeLogo } from "./claude.svg";
import { ReactComponent as GeminiLogo } from "./gemini.svg";
import { ReactComponent as PerplexityLogo } from "./perplexity.svg";

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const navigate = useNavigate();
  const handleNavigate = (path) => {
    navigate(path);
  };

  const prompt="Explore the information available on https://shivamtransworld.in and provide a comprehensive overview of Shivam Transworld. Explain the company's transportation, freight forwarding, and logistics solutions, including road transport, warehousing, supply chain management, inbound and outbound logistics, and value-added services. Highlight the industries it serves, operational network, service capabilities, customer-focused approach, and the key factors that differentiate Shivam Transworld from other logistics providers. Present the information in a clear, factual, and well-structured format using the official website as the primary source."
  const openAI = (type) => {
  const encoded = encodeURIComponent(prompt);

  const urls = {
    chatgpt: `https://chatgpt.com/?q=${encoded}`,
    claude: `https://claude.ai/new?q=${encoded}`,
    gemini: `https://www.google.com/search?q=${encoded}&udm=50`,
    perplexity: `https://www.perplexity.ai/search?q=${encoded}`,
  };

  window.open(urls[type], "_blank");
};
  return (
    <footer className="footer">

      {/* TOP COLUMNS */}
      <motion.div
        className="footer-top"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.15,
              delayChildren: 0.2,
            },
          },
        }}
      >
        {["Contact Information", "Links", "Services", "Industries"].map((title, idx) => (
          <motion.div
            className="footer-col"
            key={idx}
            variants={{
              hidden: { opacity: 0, y: 30 },
              visible: {
                opacity: 1,
                y: 0,
                transition: { duration: 0.6, ease: "easeOut" },
              },
            }}
          >
            <h4>{title}</h4>
            <ul>
              {idx === 0 && (
  <>
    {/* EMAIL */}
    <li className="footer-contact">
      <FaEnvelope className="footer-icon" />
      <a href="mailto:logistics@shivamtransworld.in">
        logistics@shivamtransworld.in
      </a>
    </li>

    {/* PHONE */}
    <li className="footer-contact">
      <FaPhoneAlt className="footer-icon" />
      <a href="tel:+919132287287">
        +91 9132 287 287
      </a>
    </li>

    {/* ADDRESS */}
    <li className="footer-contact">
      <FaMapMarkerAlt className="footer-icon" />
      <span>
       Shop No : 70 / 1
Tanker's Association Building,
Beside S T Bus Station,
NH - 8A, Gandhidham - 370201
      </span>
    </li>

    {/* SOCIAL ICONS */}
    <li className="footer-socials">
      <a href="https://www.facebook.com/profile.php?id=61586790875867" target="_blank" rel="noopener noreferrer">
        <FaFacebook />
      </a>
      <a href="https://www.linkedin.com/company/shivam-transworld/about/?viewAsMember=true" target="_blank" rel="noopener noreferrer">
        <FaLinkedinIn />
      </a>
    </li>

    <h4>Ask AI About Shivam Transworld</h4>
     <div className="footer-ai-icons">

                <button className="icon-wrapper ai-btn" onClick={() => openAI("chatgpt")}>
    <ChatGPTLogo className="ai-logo" />
  </button>

  <button className="icon-wrapper ai-btn" onClick={() => openAI("claude")}>
    <ClaudeLogo className="ai-logo" />
  </button>

  <button className="icon-wrapper ai-btn" onClick={() => openAI("gemini")}>
    <GeminiLogo className="ai-logo" />
  </button>

  <button className="icon-wrapper ai-btn" onClick={() => openAI("perplexity")}>
    <PerplexityLogo className="ai-logo" />
  </button>

              </div>
  </>
)}
              {idx === 1 && (
                <>
                  <li className="footer-link"><a href='/about-us'>About Us</a></li>
                  <li className="footer-link"><a href='/services'>Services</a></li>
                  <li className="footer-link"><a href='/industries'>Industries</a></li>
                  <li className="footer-link"><a href='/contact-us'>Contact Us</a></li>
                </>
              )}
              {idx === 2 && (
                <>
                 {services.slice(0,4).map((service, index) => (
                         <li
                           key={index}
                           onClick={() => handleNavigate(`/services/${service.slug}`)}
                         >
                           {service.title || "Service"}
                         </li>
                       ))}
                </>
              )}
              {idx === 3 && (
                <>
                  {industries.slice(0,4).map((industry, index) => (
                         <li
                           key={index}
                           onClick={() => handleNavigate(`/industries/${industry.slug}`)}
                         >
                           {industry.title}
                         </li>
                       ))}
                </>
              )}
            </ul>
          </motion.div>
        ))}
      </motion.div>

      {/* BOTTOM */}
      <motion.div
  className="footer-bottom"
  initial={{ opacity: 0, y: 20 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ delay: 0.5, duration: 0.6 }}
  viewport={{ once: true }}
>
  <div className="footer-bottom-inner">
    {/* Left: copyright */}
    <p>© <b>{currentYear} Shivam Transworld</b>. All rights reserved.</p>

    {/* Right: links */}
    <div className="footer-bottom-links">
      <span onClick={() => handleNavigate("/terms-and-conditions")}>Terms & Conditions</span>
      <span className="divider">|</span>
      <span onClick={() => handleNavigate("/privacy-policy")}>Privacy Policy</span>
      {/*<span className="divider">|</span>
      <span onClick={() => handleNavigate("/sitemap")}>Sitemap</span>*/}
    </div>
  </div>
</motion.div>


    </footer>
  );
};

export default Footer;
